import { Swiper, Navigation } from 'swiper';

if (document.querySelector('.js-products-slider')) {
  const HomePageProductCatSlider = new Swiper(".js-products-slider", {
      speed: 500,
      modules: [Navigation],
      simulateTouch: true,
      spaceBetween: -1,
      loop: true,
      slidesPerView: "auto",
      centeredSlides: true,
      navigation: {
        nextEl: ".js-products-slider-next-30",
        prevEl: ".js-products-slider-prev-30",
      },
  });
}